/* FileHelper.js */
/* @author: anghello */

const PZ_DOWNLOAD_URL = process.env.REACT_APP_PZ_DOWNLOAD_URL;

const FileHelper = {
  readFile: (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = res => {
        resolve(res.target.result);
      };
      reader.onerror = err => reject(err);

      reader.readAsDataURL(file);
    });
  },

  dataURItoBlob: (dataURI) => {
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(dataURI.split(',')[1]);
    else
      byteString = decodeURI(dataURI.split(',')[1]);

    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  },

  getRemoteFileBlob: async (imageUrl) => {
    if (!imageUrl || typeof imageUrl !== 'string') {
      throw new Error('Invalid URL');
    }

    let urlMedia = imageUrl.trim();
    urlMedia = urlMedia.replace(/^https?:\/+/i, '');
    urlMedia = urlMedia.replace(/^\/+/, '');
    urlMedia = `https://${urlMedia}`;

    try {
      new URL(urlMedia);
    } catch (error) {
      throw new Error('Invalid URL format');
    }

    const downloadURL = urlMedia;

    const validateBlob = (blob) => {
      if (!blob || blob.size === 0) {
        throw new Error('Empty or blocked file');
      }

      const validTypes = ['image/', 'video/', 'audio/'];
      const isValidType = validTypes.some(type => blob.type.startsWith(type));
      if (!isValidType && blob.type !== '') {
        console.warn('Unrecognized file type:', blob.type);
      }

      return blob;
    };

    const isCrossOrigin = (absoluteUrl) => {
      if (typeof window === 'undefined' || !window.location) {
        return true;
      }
      try {
        return new URL(absoluteUrl).origin !== window.location.origin;
      } catch {
        return true;
      }
    };

    const fetchBlobCors = async (fetchUrl) => {
      const response = await fetch(fetchUrl, { mode: 'cors', credentials: 'omit' });
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      return response.blob();
    };

    const fetchBlobViaProxy = async () => {
      const _t = Date.now();
      // PZ_DOWNLOAD_URL ends with "?filename=" — additional params must use "&", not a second "?".
      const encodedFilename = encodeURIComponent(urlMedia);
      const proxyUrl = `${PZ_DOWNLOAD_URL}${encodedFilename}&_t=${_t}`;
      const response = await fetch(proxyUrl, { mode: 'cors', credentials: 'omit' });
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      return response.blob();
    };

    const crossOrigin = isCrossOrigin(urlMedia);

    if (crossOrigin) {
      try {
        const blob = await fetchBlobViaProxy();
        return validateBlob(blob);
      } catch (error) {
        console.error('Proxy download error:', error.message);
      }
      try {
        const blob = await fetchBlobCors(downloadURL);
        return validateBlob(blob);
      } catch (error) {
        console.error('Direct download error:', error.message);
      }
    } else {
      try {
        const blob = await fetchBlobCors(downloadURL);
        return validateBlob(blob);
      } catch (error) {
        console.error('Direct download error:', error.message);
      }
      try {
        const blob = await fetchBlobViaProxy();
        return validateBlob(blob);
      } catch (error) {
        console.error('Proxy download error:', error.message);
      }
    }

    throw new Error('Unable to download file. It may be blocked or inaccessible.');
  },
};

export default FileHelper;
